import axios from "axios";
import { APIURL } from "../config";
import useAuth from "../utils/useAuth";


const SetProfileDataAPI = async (data) => {
    const user = useAuth()
    const url = APIURL + "/account/editprofile"
    return await axios.post(url, { access_token: user.token, ...data })
}

export default SetProfileDataAPI